import { AxiosRequest } from "../../../Url";
import { ParamSetOption } from "../../Tools/ProjectX";
import { getTableLayout } from "../../Tools/Requests";
import { defaultFieldInfo, getModalSectionID, getRightsData } from "../../Tools/Tools";
import { getParamColumnsOptions, parseColumns } from "../GridTools/parseColumnTools";
import { createGrid, createRecordSource } from "../rcsgrid";

export async function booksGrid(grid: createGrid, source: createRecordSource, props, data) {
  const json = await getTableLayout({ module: props.Module, objType: props.ObjType, sectionId: props.SectionID });
  source.onHandleRequest = handleRequest(props);

  await source.open();

  if (json) {
    source.rights = getRightsData(json.Rights);

    if (json.ReadOnly === "1") grid.OnlyViewMode = true;

    const columns = {
      title: [
        {
          fieldName: "ID",
          title: "Ключ",
          width: 80,
          level: 0,
          hide: true,
          hideInGrid: true,
          hideInCard: true,
          options: getParamColumnsOptions(ParamSetOption.Hidden),
          fieldInfo: { ...defaultFieldInfo },
        },
      ],
    };

    grid.setColumns(parseColumns(json, { inputColumns: columns }));
  } else grid.defaultColumns = true;
  if (!props.ObjRef) await source.refresh();
  await grid.setSource(source);
  if (props.ObjRef) await grid.refreshSource(props.ObjRef);
  await grid.updateGridSize();
}

function handleRequest(props) {
  return (request) => {
    const params = new Map();
    params
      .set("prefix", props.Module)
      .set("comand", "HandleTable")
      .set("ObjType", props.ObjType)
      .set("SectionID", props.SectionID ? props.SectionID : getModalSectionID());
    return AxiosRequest(true, params, request);
  };
}
